import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  CircularProgress,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {useAuthContext} from '../context/AuthContext';


const DebtEntry = () => {
  const [formData, setFormData] = useState({
    afm: '',
    companyName: '',
    debtYear: '',
    debtAmount: '',
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Χρησιμοποιούμε το setNotification από το Context/Hook
  const { setNotification } = useAuthContext();

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Ειδικός έλεγχος για να δέχεται μόνο αριθμούς στα πεδία 'afm', 'debtYear'
    if (name === 'afm' || name === 'debtYear') {
      if (!/^\d*$/.test(value)) return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // --- 1. Έλεγχοι Εγκυρότητας (Validation) ---

    // Έλεγχος για κενά πεδία
    if (!formData.afm || !formData.companyName || !formData.debtYear || !formData.debtAmount) {
      setLoading(false);
      setNotification({
        message: 'Παρακαλώ συμπληρώστε όλα τα πεδία.',
        open: true,
        color: 'error',
      });
      return;
    }

    // Έλεγχος μήκους ΑΦΜ
    if (formData.afm.length !== 9) {
      setLoading(false);
      setNotification({
        message: 'Το ΑΦΜ πρέπει να έχει 9 ψηφία.',
        open: true,
        color: 'error',
      });
      return;
    }

    // --- 2. Κλήση API ---
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/insertDebtManual`,
        {
          afm: formData.afm,
          companyName: formData.companyName,
          debtYear: parseInt(formData.debtYear, 10),
          debtAmount: parseFloat(formData.debtAmount),
        },
        { withCredentials: true }
      );

      // --- Επιτυχής Υποβολή (Success) ---
      setLoading(false);
      setNotification({
        message: 'Η οφειλή καταχωρήθηκε επιτυχώς!',
        open: true,
        color: 'success',
      });

      // Καθαρισμός της φόρμας
      setFormData({
        afm: '',
        companyName: '',
        debtYear: '',
        debtAmount: '',
      });

    } catch (error) {
      // --- Σφάλμα Υποβολής (Error) ---
      console.error('Σφάλμα κατά την καταχώρηση:', error.response?.data || error.message);

      const errorMessage = error.response?.data?.message || 'Αποτυχία καταχώρησης οφειλής. Δοκιμάστε ξανά.';

      setLoading(false);
      setNotification({
        message: errorMessage,
        open: true,
        color: 'error',
      });

    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        padding: '20px',
      }}
    >
      <Paper elevation={3} sx={{ padding: 4, maxWidth: 500, width: '100%' }}>
        <Typography variant='h5' component='h1'
          gutterBottom align='center'>
          Εισαγωγή Οφειλής προς Βεβαίωση
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin='normal'
            label='ΑΦΜ Οφειλέτη'
            name='afm'
            value={formData.afm}
            onChange={handleChange}
            required
            inputProps={{ maxLength: 9, inputMode: 'numeric', pattern: '[0-9]*' }}
            disabled={loading}
          />
          <TextField
            fullWidth
            margin='normal'
            label='Επωνυμία Οφειλέτη'
            name='companyName'
            value={formData.companyName}
            onChange={handleChange}
            required
            disabled={loading}
          />
          <TextField
            fullWidth
            margin='normal'
            label='Έτος Οφειλής'
            name='debtYear'
            value={formData.debtYear}
            onChange={handleChange}
            required
            inputProps={{ maxLength: 4, inputMode: 'numeric', pattern: '[0-9]*' }}
            disabled={loading}
          />
          <TextField
            fullWidth
            margin='normal'
            label='Ποσό Οφειλής (€)'
            name='debtAmount'
            value={formData.debtAmount}
            onChange={handleChange}
            required
            type='number'
            inputProps={{ step: '0.01' }}
            disabled={loading}
          />
          <Button
            type='submit'
            fullWidth
            variant='contained'
            endIcon={loading
              ? <CircularProgress size={20} color='inherit' />
              : <SendIcon />}
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            Καταχώρηση Οφειλής
          </Button>
        </form>
        <Button
          fullWidth
          variant='outlined'
          onClick={() => navigate(-1)}
          disabled={loading}
        >
          Ακύρωση / Πίσω
        </Button>
      </Paper>
    </Box>
  );
};

export default DebtEntry;
